module.exports = __webpack_public_path__ + "img/loading.1d0964c6.svg";